import styles from './red-flags-step.module.scss';
import { RedFlagCategory } from '../tech-due-diligence-quiz.types';

type RedFlagsStepProps = {
  category: RedFlagCategory;
  flags: Record<string, boolean>;
  onToggle: (itemIndex: number) => void;
};

export const GateCheckFlagIcon = ({ fill }: { fill: string }) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={{ marginRight: 4 }}
  >
    <path
      d="M19.375 8.125C19.3751 8.25483 19.3347 8.38145 19.2595 8.4873C19.1844 8.59314 19.0781 8.67294 18.9555 8.71562L5 13.5695V16.875C5 17.0408 4.93415 17.1997 4.81694 17.3169C4.69973 17.4342 4.54076 17.5 4.375 17.5C4.20924 17.5 4.05027 17.4342 3.93306 17.3169C3.81585 17.1997 3.75 17.0408 3.75 16.875V3.125C3.74994 3.02524 3.77377 2.92691 3.81948 2.83824C3.86519 2.74957 3.93147 2.67313 4.01277 2.61531C4.09407 2.55749 4.18803 2.51997 4.28679 2.50589C4.38555 2.49181 4.48625 2.50158 4.58047 2.53438L18.9555 7.53438C19.0781 7.57706 19.1844 7.65686 19.2595 7.7627C19.3347 7.86854 19.3751 7.99517 19.375 8.125Z"
      fill={fill}
    />
  </svg>
);

const RedFlagsStep = ({ category, flags, onToggle }: RedFlagsStepProps) => (
  <div className={styles.list}>
    {category.items.map((item, itemIndex) => {
      const checked = !!flags[`${category.id}:${itemIndex}`];
      return (
        <label key={itemIndex} className={`${styles.option} ${checked ? styles.checked : ''}`}>
          <span className={styles.checkbox}>
            <input
              type="checkbox"
              checked={checked}
              onChange={() => onToggle(itemIndex)}
              className={styles.checkboxInput}
            />
            <span className={styles.checkboxVisual} />
          </span>
          <span className={styles.optionText}>{item}</span>
        </label>
      );
    })}
  </div>
);

export default RedFlagsStep;
